import { httpService } from "./http.service";

const BASE_URL = "dashboard";

export const dashboardService = {
  getAll,
  getById,
  create,
  update,
  removeItem,
  getChartsByBoardId,
  getChartData,
  updateItem,
  getAccumulatorData,
  getChartRecommendations,
};

async function getAll() {
  return await httpService.get(BASE_URL);
}

async function getById(id) {
  return await httpService.get(`${BASE_URL}/${id}`);
}

async function create(data, accountId) {
  return await httpService.post(`${BASE_URL}/${accountId}`, data);
}

async function update(id, orderData, accountId) {
  return await httpService.patch(`${BASE_URL}/${id}/order`, { orderData, accountId });
}

async function updateItem(dashboardId, id, data, accountId) {
  return await httpService.put(`${BASE_URL}/${dashboardId}/item/${id}`, { data, accountId });
}

async function removeItem(dashboardId, itemId, accountId) {
  return await httpService.delete(`${BASE_URL}/${dashboardId}/item/${itemId}`, {
    data: { accountId },
  });
}

async function getChartsByBoardId(boardId) {
  return await httpService.get(`${BASE_URL}/by-board/${boardId}`);
}

async function getChartData(chartId) {
  return await httpService.get(`${BASE_URL}/chartData/${chartId}`);
}

async function getAccumulatorData(id) {
  return await httpService.get(`${BASE_URL}/accumulatorData/${id}`);
}

async function getChartRecommendations(boardId, { includePreview = false, limit = 10 } = {}) {
  const qp = new URLSearchParams();
  if (includePreview) qp.set("includePreview", "1");
  if (limit != null) qp.set("limit", String(limit));
  const qs = qp.toString();
  return await httpService.get(`${BASE_URL}/recommendations/${boardId}${qs ? `?${qs}` : ""}`);
}